import styled from "styled-components";

export const LoadingWrapper = styled.div`
  min-height: 45vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.95rem;
`;
